import { ItemEntity } from '@entities/Item/Types';
import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';

export const GetParsedFragmentItemsWithoutLabour = (
    uuid: string,
    parsedFragments: ParsedFragmentEntity[]
) => {
    const currentFragment = parsedFragments.find(
        fragment => fragment.uuid === uuid
    );

    if (!currentFragment) {
        return [];
    }

    const filteredItemTypes = currentFragment.itemTypes.filter(
        itemType => !itemType.labor
    );

    return filteredItemTypes
        .flatMap(itemType => itemType.items)
        .filter(Boolean) as ItemEntity[];
};
